import { render } from "./ActionModal.vue?vue&type=template&id=3ffbb9b8&ts=true"
import script from "./ActionModal.vue?vue&type=script&lang=ts"
export * from "./ActionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__